import classNames from 'classnames';
import { ref, update, get } from 'firebase/database';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { renderNotificationItem } from './notificationUtils';
import { setOpenMaterialFlag, subjectsObjKey } from '../../Common/Database';
import { database } from '../../Common/Firebase';

function Notification({ notificationRef, openNotif, students, items, closeFunc, userMail, userType }) {
  const navigate = useNavigate();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [combinedItems, setCombinedItems] = useState([]);
  const [itemsToShow, setItemsToShow] = useState(10);
  const [student, setStudent] = useState({});

  const correctEmail = userMail => {
    if (!userMail) return userMail;
    let userMailNew = userMail.replace(/\./g, '');
    if (userMailNew.endsWith('com') && !userMailNew.includes('.com')) {
      userMailNew = userMailNew.slice(0, -3) + '.com';
    }

    return userMailNew;
  };

  const findStudent = mail => {
    let student = students.find(student => correctEmail(student.email) === correctEmail(mail));
    return student;
  };

  useEffect(() => {
    const sortByTime = (a, b) => {
      const dateA = new Date(a.time.replace(/(\d{2}) (\d{2}) (\d{4}) (\d{2}):(\d{2})/, '$2/$1/$3 $4:$5'));
      const dateB = new Date(b.time.replace(/(\d{2}) (\d{2}) (\d{4}) (\d{2}):(\d{2})/, '$2/$1/$3 $4:$5'));

      return dateB - dateA;
    };

    const viewedItems = items.filter(item => item.viewed === true).sort(sortByTime);
    const notViewedItems = items
      .filter(item => item.viewed === false)
      .sort(sortByTime)
      .slice(0, itemsToShow);
    const combinedItems = [...viewedItems, ...notViewedItems];
    setCombinedItems(combinedItems);
  }, [items, itemsToShow]);

  useEffect(() => {
    let student = students.find(student => correctEmail(student.email) === correctEmail(userMail));
    setStudent(student);
  }, [students]);

  const showMoreItems = () => {
    setItemsToShow(prev => prev + 5);
  };

  const allCheckNatif = async () => {
    const user = userType === 'Student' ? 'Students' : 'Teachers';
    const dbRef = ref(database, `${user}/${userMail}/notification`);
    try {
      const snapshot = await get(dbRef);
      const data = snapshot.val();
      if (data) {
        const updates = {};
        for (let key in data) {
          updates[key + '/viewed'] = false;
        }
        await update(dbRef, updates);
      }
    } catch (error) {
      console.error('Ошибка при обновлении:', error.message);
    }
  };

  const buildUrl = item => {
    const studentTeacher = findStudent(item.mail);
    const currentStudent = student === undefined ? studentTeacher : student;

    switch (item.type) {
      case 'materials':
        if ('subType' in item && item.subType === 'Book') {
          return window.location.origin + '/materialView/' + item.id;
        } else if ('subType' in item && item.subType === 'Exam') {
          return window.location.origin + '/materialView/' + item.id;
        }
        break;
      case 'materials interative-exum':
        const checklistDate = currentStudent.materials[item.idItem];
        navigate(`/checklist-editor-student/${item.id}`, {
          state: {
            ...checklistDate,
            studentId: currentStudent.email.replace(/\./g, ''),
            firstName: currentStudent.firstName,
            lastName: currentStudent.lastName,
          },
        });
        closeFunc();
        break;
      case 'notebook':
        return window.location.origin + `/notebook/${userMail}/${item.subject}`;
      case 'subjects':
      case 'subjects add-teacher':
        return window.location.origin + `/subject/${userMail}/${item.subject}`;
      case 'subjects add-student':
        return window.location.origin + `/studentView/${item.studentMail}`;
      case 'subjects add-group':
        return window.location.origin + `/students-group-view/${item.studentMail}`;
      case 'homeworks':
        return window.location.origin + `/student-homework-list/${currentStudent.homeworks[item.idItem].subject}`;
      case 'homeworks-student homeworks-points setItemPointHomeworkChecked':
      case 'homeworks-student homework setItemPointHomeworkChecked':
      case 'homeworks-student homeworks-points setItemPointHomeworkFile':
      case 'homeworks-student homework setItemPointHomeworkFile':
        return window.location.origin + `/student-homework-list/${item.subject}/${item.mail}`;
      default:
        return window.location.origin + '/';
    }
  };

  const handleNavigationItem = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    const studentTeacher = findStudent(item.mail);
    const currentStudent = student === undefined ? studentTeacher : student;
    allCheckNatif();

    const url = buildUrl(item);

    if (e.button === 1) {
      // Средняя кнопка мыши
      window.open(url, '_blank');
    } else {
      // Левая кнопка мыши
      switch (item.type) {
        case 'materials':
          setOpenMaterialFlag(userMail, 'materials', item.id);
          if ('subType' in item && item.subType === 'Book') {
            if (currentStudent.materials[item.idItem]) {
              navigate('/materialView', {
                state: currentStudent.materials[item.idItem],
              });
            }
            closeFunc();
          } else if ('subType' in item && item.subType === 'Exam') {
            navigate('/materialView', {
              state: currentStudent.materials[item.idItem],
            });
            closeFunc();
          }
          break;
        case 'materials interative-exum setItemPointExumChecked':
        case 'materials interative-exum setItemNotPointExumChecked':
        case 'materials interative-exum studentDateCompleted':
        case 'materials interative-exum setStudentPhoto':
          const checklistDate = currentStudent.materials[item.idItem];
          navigate(`/checklist-teacher/${checklistDate.id}`, {
            state: {
              ...checklistDate,
              studentId: currentStudent.email.replace(/\./g, ''),
              firstName: currentStudent.firstName,
              lastName: currentStudent.lastName,
            },
          });
          closeFunc();
          break;
        case 'materials interative-exum':
          setOpenMaterialFlag(userMail, 'materials', item.id);
          navigate(`/checklist-editor-student/${item.id}`, {
            state: currentStudent.materials[item.idItem],
          });
          closeFunc();
          break;
        case 'notebook':
          navigate(`/notebook/${userMail}/${item.subject}`);
          closeFunc();
          break;
        case 'subjects':
          navigate(`subject/${userMail}/${item.subject}`);
          closeFunc();
          break;
        case 'subjects add-teacher':
          navigate(`subject/${userMail}/${item.subject}`);
          closeFunc();
          break;
        case 'subjects add-student':
          navigate(`studentView/${item.studentMail}`);
          closeFunc();
          break;
        case 'subjects add-group':
          navigate(`students-group-view/${item.studentMail}`);
          closeFunc();
          break;
        case 'homeworks':
          navigate(`/student-homework-list/${currentStudent.homeworks[item.idItem].subject}`);
          closeFunc();
          break;
        case 'homeworks-student homeworks-points setItemPointHomeworkChecked':
        case 'homeworks-student homework setItemPointHomeworkChecked':
        case 'homeworks-student homeworks-points setItemPointHomeworkFile':
        case 'homeworks-student homework setItemPointHomeworkFile':
          navigate(`/student-homework-list/${item.subject}/${item.mail}`);
          closeFunc();
          break;
      }
    }
  };

  const closePopup = () => {
    closeFunc();
    allCheckNatif();
  };

  function formatDate(dateStr) {
    const dateStrNew = dateStr.replace(/ /g, (match, offset, string) =>
      offset === string.lastIndexOf(' ') ? ' ' : '.',
    );
    const [datePart, timePart] = dateStrNew.split(' ');
    const [day, month, year] = datePart.split('.');
    const [hours, minutes] = timePart.split(':');
    const inputDate = new Date(`${year}-${month}-${day}T${hours}:${minutes}`);
    const currentDate = new Date();
    const diffInMinutes = (currentDate - inputDate) / (1000 * 60);

    if (
      inputDate.getDate() === currentDate.getDate() &&
      inputDate.getMonth() === currentDate.getMonth() &&
      inputDate.getFullYear() === currentDate.getFullYear()
    ) {
      if (diffInMinutes < 60) {
        return `${Math.round(diffInMinutes)} ${t('minutes ago')}`;
      } else {
        return `${Math.round(diffInMinutes / 60)} ${t('hours ago')}`;
      }
    }
    return datePart;
  }

  return (
    <div ref={notificationRef} className={classNames('drop-wrap', { open: openNotif })}>
      <div className="drop-wrap-item">
        <div className="notification-top-row">
          <button className="btn btn-icon" onClick={closePopup}>
            <span className="icon icon-plus"></span>
          </button>
        </div>

        {/* Notifications not read */}
        {combinedItems && combinedItems?.some(item => item.viewed) && (
          <div className="unread-notifications">
            <h2>{t('Unread')}</h2>
            <ul className="notification-items">
              {combinedItems
                ?.filter(item => item.viewed)
                ?.map(item => {
                  return (
                    <li
                      key={item?.id}
                      className={classNames('notification-item', {
                        active: item.viewed,
                      })}
                    >
                      {renderNotificationItem(
                        item,
                        t,
                        language,
                        handleNavigationItem,
                        student,
                        subjectsObjKey,
                        findStudent,
                        formatDate,
                        buildUrl,
                        navigate,
                      )}
                    </li>
                  );
                })}
            </ul>
          </div>
        )}

        {combinedItems && combinedItems?.some(item => !item?.viewed) && (
          <div className="read-notifications">
            <h2>{t('Read')}</h2>
            <ul className="notification-items">
              {combinedItems &&
                combinedItems
                  .filter(item => !item.viewed)
                  .map(item => {
                    return (
                      <li
                        key={item?.id}
                        className={classNames('notification-item', {
                          active: item?.viewed,
                        })}
                      >
                        {renderNotificationItem(
                          item,
                          t,
                          language,
                          handleNavigationItem,
                          student,
                          subjectsObjKey,
                          findStudent,
                          formatDate,
                          buildUrl,
                          navigate,
                        )}
                      </li>
                    );
                  })}
            </ul>

            {combinedItems && combinedItems.length < items.length && (
              <button className="read-more" onClick={showMoreItems}>
                {t('read more')}
              </button>
            )}
          </div>
        )}

        {combinedItems && combinedItems.length < 1 && (
          <span className="title">{t("You don't have any notifications yet")}</span>
        )}
      </div>
    </div>
  );
}

export default Notification;
